import Immutable from "seamless-immutable";
import * as actionTypes from "./actionTypes";

const initialState = Immutable({
  byId: {},
  params: {},
  pageLogs: {},
  userLogs: {},
  platformLogs: {},
  actionsloading: false,
});
export function webLogsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SAVE_PAGE_VISIT_LOGS:
    case actionTypes.GET_PAGE_VISIT_LOGS:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.GET_PAGE_VISIT_LOGS_SUCCESS:
      return {
        ...state,
        userLogs: action.payload.userLogs || {},
        pageLogs: action.payload.pageLogs || {},
        platformLogs: action.payload.platformLogs || {},
        actionsloading: false,
      };
    case actionTypes.SAVE_PAGE_VISIT_LOGS_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.weblogsUid]: action.payload,
        },
        actionsloading: false,
      };
    default:
      return state;
  }
}
